export default __webpack_public_path__ + "static/media/licenses-bg-after.dfcd07c4.png";